import { Product } from 'components/Product'
import { Route, Routes } from 'react-router-dom'

export const Router = () => (
  <Routes>
    <Route path="/:sku/:bu" element={<Product />} exact />
    <Route path="/:sku" element={<Product />} exact />
  </Routes>
)
